export default {
    title: 'Our perception',
    placeholder: '<em>There is no evaluation available yet.</em>',
    overlay: {
        description: 'Please select the trends for entering the evaluation in the edit mode of the trend radar.',
        button: 'Switch to the edit mode'
    }
}
